module.exports = __webpack_public_path__ + "static/media/11fiducia.5fba177.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/11fiducia.mp4
// module id = 719
// module chunks = 1